import { getUserDetails } from "../../generated/getUserDetails";

const mockUserData: getUserDetails = {
  user: {
    id: "1b335cd6-b6fb-44c9-bddd-4acf549587b2",
    emailVerified: true,
    username: "robert_garcia",
    firstName: "Robert",
    lastName: "Garcia",
    email: "robert_garcia@fgpe.usz.edu.pl",
    __typename: "User",
  },
};

export default mockUserData;
